import {Card} from './components/card';
import {Container} from './components/container';

export const HierarchyNavigationCard = {
	Container,
	Card,
};
